<template>
  <v-app id="inspire">
    <v-app-bar app>
      <div class="d-flex align-center">
        <v-img
          alt="RSU Logo"
          class="shrink mr-2 pointer"
          contain
          src="./assets/asclogo.png"
          transition="scale-transition"
          width="200"
          @click="goto('/')"
        />
      </div>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <!-- <v-btn
          v-if="signInState"
          @click="goto('/checkprivilege')"
          text
          class="hidden-sm-and-down"
        >
          <span class="mr-2">ตรวจสอบสิทธิ์</span>

        </v-btn> -->
        <v-btn
          v-if="signInState && role == 'rsu'"
          @click="goto('/transaction')"
          text
          class="hidden-sm-and-down"
        >
          <span class="mr-2">ข้อมูลบริการวิชาการ</span>
          <!-- <v-icon>mdi-open-in-new</v-icon> -->
        </v-btn>
        <v-btn
          v-if="signInState && role == 'asc'"
          @click="goto('/transactionASC')"
          text
          class="hidden-sm-and-down"
        >
          <span class="mr-2">ข้อมูลบริการวิชาการทั้งหมด</span>
          <!-- <v-icon>mdi-open-in-new</v-icon> -->
        </v-btn>

        <v-btn
          v-if="signInState"
          @click="SignOut"
          text
          class="hidden-sm-and-down"
        >
          <span v-if="userData" class="mr-2"
            >{{ userData.emp_name_tha }} ({{ userData.emp_id }})
          </span>
          <span class="no-print">ออกจากระบบ</span>
          <!-- <v-icon>mdi-open-in-new</v-icon> -->
        </v-btn>
      </v-toolbar-items>

      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="hidden-md-and-up no-print"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list-item v-if="signInState">
        <v-list-item-content>
          <v-img src="./assets/asclogo.png"></v-img>
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-title>{{ user.displayName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item link v-if="!signInState">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title @click="goto('/')"
              >Please Sign In</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item link v-if="signInState">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title @click="SignOut">Sign Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
// import store from "./store";
import { GlobalFunction } from "./views/functions";

export default {
  mixins: [GlobalFunction],
  name: "App",

  data: () => ({
    user: {},
    drawer: null,
    signInState: false,
  }),

  methods: {
    goto(path) {
      if (this.$route.path != path) {
        this.$router.push(path);
      }
    },
    menuItems() {
      return this.menu;
    },
  },
  async mounted() {
    await this.authStateChanged();

    // console.log(this.role);
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}

#inspire {
  font-family: "rsu", sans-serif;
}

.rsu {
  font-family: "rsu", sans-serif;
}

@font-face {
  font-family: rsu;
  src: url(./assets/RSU_Regular.ttf);
}

@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
}
</style>
